import { render, staticRenderFns } from "./MailBoxFixClient.vue?vue&type=template&id=78a53ca2&scoped=true"
import script from "./MailBoxFixClient.vue?vue&type=script&lang=js"
export * from "./MailBoxFixClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a53ca2",
  null
  
)

export default component.exports